import { useEffect, useState, useMemo } from "react";
import { getData } from "../../../../services/library";
import moment from "moment";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { logEventos } from "../../../../services/services";
import Navbar from "../../../Navbar";
import { Divider, Container, Box, Typography, MenuItem, ListItemIcon, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { Preview } from '@mui/icons-material';
import Openpdf from '../../OpenPdf';

export default function Historial(props) {
    const [ordenes, setordenes] = useState([]);
    const [showTabla, setshowTabla] = useState(true);
    const [openclose, setopenclose] = useState(false);
    const [dataReq, setdataReq] = useState({});
    let suc_auth = localStorage.getItem('suc_auth');

    const getOrdenes = () => {
        getData(`/ordencompra/historial/${suc_auth}`, setordenes)
    };

    useEffect(() => {
        getOrdenes();
        logEventos('Visualizar historial de ordenes', 'Historial de ordenes', 'Compras', localStorage.getItem('user'));
    }, []);

    const columns = useMemo(() =>
        [{ header: '#', accessorKey: 'idordencompra', size: 90 },
        { header: 'Movil', accessorKey: 'patente', size: 120 },
          { header: 'Proveedor', accessorFn: (ordenes) => ordenes.nombre_fantasia ? ordenes.nombre_fantasia : ordenes.razon_social, },
            { header: 'Cond venta', accessorFn: (ordenes) => ordenes.condicion, accessorKey:"condicion" },
        { header: 'Solicitado', accessorFn: (req) => moment(req.created_at).format("DD-MM-YYYY"), size: 100 },
       
        { header: 'Sucursal', accessorFn: (req) => `${req.nombre_sucursal}`, accessorKey: "nombre_sucursal" }
        ], []);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 1000 },
    };

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const handleViewData = (data) => {
        setopenclose(true)
        setshowTabla(false)
        setdataReq(data)
    };

    return (
        <div>
            <Navbar />
            <Container maxWidth="xl" mt={1} mb={2}>
                {ordenes && showTabla ? (
                    <Box mt={2} boxShadow={3}>
                        <MaterialReactTable
                            columns={columns}
                            data={ordenes}
                            enableBottomToolbar={true}
                            enablePagination={true}
                            enableRowActions
                            enableRowVirtualization
                            initialState={initialState}
                            positionActionsColumn="last"
                            muiTableHeadCellProps={tableHeadCellProps}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    if (event.target.closest("button, a, [role='menuitem']")) return;
                                    handleViewData(row.original);
                                },
                                sx: { cursor: "pointer" },
                            })}
                            muiTableBodyCellProps={({ row }) => ({
                                align: "center",
                                sx: {
                                    backgroundColor: "#fff",
                                    color: "black",
                                    borderColor: "black",
                                },
                            })}
                            enableColumnActions={false}
                            enableDensityToggle={false}
                            muiSearchTextFieldProps={muiSearchTextFieldProps}
                            layoutMode='grid'
                            enableHiding={false}
                            localization={MRT_Localization_ES}
                            enableColumnDragging={false}
                            renderTopToolbarCustomActions={() => (
                                <Typography variant="poster" fontSize={26}>
                                    Historial ordenes autorizadas
                                </Typography>
                            )}
                            renderRowActionMenuItems={({ closeMenu, row }) => [
                                <MenuItem
                                    key={0}
                                    // disabled={(row.original.estado !== 49) && (row.original.estado) !== 87 && (row.original.estado !== 93)}
                                    onClick={() => {
                                        handleViewData(row.original)
                                        closeMenu();
                                    }}
                                    sx={{ m: 0 }}>
                                    <ListItemIcon>
                                        <Preview color="secondary" />
                                    </ListItemIcon>
                                    Visualizar
                                </MenuItem>
                            ]}
                        />
                    </Box>
                ) : null}
            </Container>

            {
                openclose &&
                <Openpdf
                    datos={dataReq}
                    uuid={dataReq.uuid_ordencompra}
                    open={setopenclose}
                    tabla={setshowTabla}
                    tab={props.tab} />
            }

        </div>
    )

}